<template>
  <div>
    <AppSpinner
      v-if="(!$store.state.auth.account && $route.meta.auth) || isLoading || isCheckingAccessToScope || $store.getters['loader/isAppLoading'] || $store.getters['loader/isAuthenticating']"
      style="top: 50%; margin-top: -4rem; right: 50%; margin-right: -4rem"
      class="text-secondary position-fixed" size="8"
    />
    <AppAccessDenied v-else-if="!$store.getters['auth/hasAccessToScope']" :scopes="$store.getters['auth/availableScopes']"/>
    <b-overlay v-else :show="$store.getters['loader/isLoading']" z-index="9999" opacity="1" fixed>
      <router-view></router-view>

      <template #overlay>
        <AppSpinner class="text-secondary mx-auto" size="8"/>
      </template>
    </b-overlay>
    <vue-snotify></vue-snotify>
  </div>
</template>

<script>
  import AppSpinner from "./components/common/utils/AppSpinner";
  import {loadLanguageAsync} from "./shared/locales/i18n";
  import AppAccessDenied from "./components/common/utils/AppAccessDenied";
  import {getMe, logAs} from "./api/user.api";
  import {handleGetMeResponse} from "./shared/services/user";

  export default {
    name: 'app',
    components: {AppAccessDenied, AppSpinner},
    data() {
      return {
        isLoading: true,
        isCheckingAccessToScope: false,
        hasAccessToScope: true
      }
    },
    methods: {
      initLanguage(defaultLanguage) {
        loadLanguageAsync(defaultLanguage);
        return Promise.resolve()
      },
      getMe() {
        this.isCheckingAccessToScope = true;
        getMe().then(
          (response) => {
            handleGetMeResponse(response);
            this.isCheckingAccessToScope = false;
            this.isLoading = false;
          },
          (error) => {
            if (error.response.status !== 401 && error.response.data.message !== "Expired token") {
              const errorBody = this.resolveErrorMessage(error);
              localStorage.clear();
              this.$store.dispatch("auth/logout");
              window.alert(errorBody.code + ": " + errorBody.message);
              this.isCheckingAccessToScope = false;
            }
          }
        )
      },
    },
    created() {
      if (this.$store.getters["auth/idToken"]) {
        this.getMe();
      } else {
        this.initLanguage(this.$store.getters["auth/language"]).then(this.isLoading = false);
      }

      if (this.userData || (this.userData === null && this.$route.meta.auth === false)) {
        this.$store.dispatch("loader/hideLoadApp")
      }

      const loggedAs = sessionStorage.getItem("loggedAsId")
      if (loggedAs){
        logAs(loggedAs).then(
          response => {
              sessionStorage.setItem("loggedAs", JSON.stringify(response.data));
              sessionStorage.removeItem("loggedAsId")
              this.$store.dispatch("auth/logAs", response.data);
              this.$router.push("/timesheets");
              this.$store.dispatch("loader/hideLoadApp");
            },
            error => {
              this.$store.dispatch("loader/hideLoadApp");
              this.handleApiError(error);
            }
        )
      }
    },
    computed: {
      userData() {
        return this.$store.state.auth.account;
      },
    },
  }
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
